import type { CSSProperties } from 'react';

export default function Dh({ em = '0.85', style }: { em?: string; style?: CSSProperties } = {}) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-label="AED"
      style={{
        width: `${em}em`, height: `${em}em`,
        display: 'inline-block', verticalAlign: '-0.04em',
        marginRight: '2px', flexShrink: 0,
        ...style,
      }}
    >
      <path d="M5.5 4.2c0-.5.4-.9.9-.9h4.2c4.7 0 7.9 3.3 7.9 8.5s-3.2 8.7-7.9 8.7H6.4c-.5 0-.9-.4-.9-.9V4.2z"
        fill="none" stroke="currentColor" strokeWidth="2.1" />
      <line x1="2.5" y1="10.2" x2="16.5" y2="10.2" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" />
      <line x1="2.5" y1="14.2" x2="16.5" y2="14.2" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" />
    </svg>
  );
}
